export default __webpack_public_path__ + "static/media/Reports.Counter.370937a8.svg";